<template>
  <section class="project-plan" v-loading="loading">
    <p class="hint">记录项目待办与截止时间。这里的事项不会启动 AI；需要团队工作时请到“团队任务”交办。</p>
    <el-alert v-if="error" :title="error" type="error" :closable="false" />
    <el-button type="primary" icon="el-icon-plus" @click="edit()">新增事项</el-button>
    <el-table :data="items" empty-text="暂无事项，添加第一条项目待办">
      <el-table-column prop="title" label="事项" min-width="240" />
      <el-table-column prop="assigneeLabel" label="负责人" width="140" />
      <el-table-column label="截止时间" width="160"><template slot-scope="s">{{ s.row.dueAt ? new Date(s.row.dueAt * 1000).toLocaleDateString() : '未设置' }}</template></el-table-column>
      <el-table-column label="状态" width="100"><template slot-scope="s"><el-tag :type="s.row.status === 'done' ? 'success' : 'info'">{{ labels[s.row.status] }}</el-tag></template></el-table-column>
      <el-table-column label="操作" width="90"><template slot-scope="s"><el-button type="text" @click="edit(s.row)">编辑事项</el-button></template></el-table-column>
    </el-table>
    <el-dialog :title="draft.itemGuid ? '编辑项目事项' : '新增项目事项'" :visible.sync="visible" width="520px" :close-on-click-modal="false">
      <el-form label-position="top">
        <el-form-item label="事项名称"><el-input v-model="draft.title" maxlength="200" placeholder="例如：核对项目报告并确认交付" /></el-form-item>
        <el-form-item label="负责人（显示名称）"><el-input v-model="draft.assigneeLabel" maxlength="80" placeholder="填写负责人的称呼，不会邀请账号或授予权限" /></el-form-item>
        <el-form-item label="截止日期"><el-date-picker v-model="draft.dueAt" type="date" value-format="timestamp" placeholder="可选截止日期" /></el-form-item>
        <el-form-item label="事项状态"><el-select v-model="draft.status"><el-option v-for="(label, value) in labels" :key="value" :value="value" :label="label" /></el-select></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="visible = false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存事项</el-button></span>
    </el-dialog>
  </section>
</template>
<script>
import { listProjectPlan, saveProjectPlan } from '@/apis/project-team'
import { buildProjectPlanItem } from '@/utils/project-plan-form.mjs'
export default {
  props: { projectGuid: { type: String, required: true } },
  data: () => ({ items: [], loading: false, saving: false, visible: false, draft: {}, error: '',
    labels: { todo: '待处理', doing: '进行中', done: '已完成' } }),
  watch: { projectGuid: { immediate: true, handler() { this.visible = false; this.items = []; this.load() } } },
  methods: {
    async load() { const id = this.projectGuid; this.loading = true; this.error = ''
      try { const data = await listProjectPlan(id); if (id === this.projectGuid) this.items = data.list }
      catch (error) { if (id === this.projectGuid) this.error = error.message }
      finally { if (id === this.projectGuid) this.loading = false } },
    edit(item) { this.draft = item ? { ...item, dueAt: item.dueAt ? item.dueAt * 1000 : null }
      : { title: '', assigneeLabel: '', dueAt: null, status: 'todo' }; this.visible = true },
    async save() { if (this.saving) return; this.saving = true
      try { await saveProjectPlan(buildProjectPlanItem(this.projectGuid, this.draft)); this.visible = false; await this.load() }
      catch (error) { this.$message.error(error.message) } finally { this.saving = false } }
  }
}
</script>
<style scoped>.hint{color:#747b8e;line-height:1.8}.project-plan>.el-button{margin:12px 0}.el-date-editor{width:100%}</style>
